import { render, staticRenderFns } from "./MoleculeEditionBillingAcademySales.vue?vue&type=template&id=3e851e3a"
import script from "./MoleculeEditionBillingAcademySales.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports